import React from 'react';

const FacebookBarCommentIcon = ({ backgroundColor, height, width }) => (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512 512" width={width} height={height}>
        <g>
            <g>
                <path d="M438.957,19.477H73.043C32.766,19.477,0,52.244,0,92.52v246.961c0,40.276,32.766,73.043,73.043,73.043h28.663    l0.561,64.483c0.05,5.943,3.463,11.344,8.809,13.942c2.173,1.056,4.512,1.575,6.84,1.575c3.399,0,6.773-1.106,9.565-3.262    l99.425-76.738h212.051c40.277,0,73.043-32.767,73.043-73.043V92.52C512,52.244,479.234,19.477,438.957,19.477z M480.696,339.482    c0,23.015-18.724,41.739-41.739,41.739H221.569c-3.46,0-6.823,1.147-9.563,3.261l-78.711,60.75l-0.422-48.495    c-0.074-8.591-7.06-15.516-15.651-15.516H73.043c-23.015,0-41.739-18.724-41.739-41.739V92.52    c0-23.015,18.724-41.739,41.739-41.739h365.915c23.015,0,41.739,18.724,41.739,41.739V339.482z" fill={backgroundColor} />
            </g>
        </g>
    </svg>
);

export default FacebookBarCommentIcon;
